module.exports = __webpack_public_path__ + "static/media/stephanieMidlength.0d1cbf22.jpg";